/**
 * @generated SignedSource<<f8acdd1eb0d7852997c67765bdac7c87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnswerPreviewSortableList_answer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedValues",
      "storageKey": null
    }
  ],
  "type": "AnswerSortableList",
  "abstractKey": null
};

node.hash = "6b7ccb9372abeb0784848afc736eed34";

module.exports = node;
